import { AmplitudeExperiments, AmplitudeVariants } from '@/utils/amplitude/experiments/AmplitudeExperiments';
import { useAmplitudeExperimentBase } from '@/utils/amplitude/experiments/utils/useAmplitudeExperimentBase';

export const useDynamicArtQuickPillsExperiment = () =>
    useAmplitudeExperimentBase(
        AmplitudeExperiments.DynamicArtQuickPills,
        AmplitudeVariants.DynamicArtQuickPills.Treatment
    );
